import React from 'react'
import { Form, Button } from 'react-bootstrap'

export const BulkProductCalculatorView = (props) => {
    return <div>
        <div><h2>Bulk Product Calculator</h2></div>
        <div>Download example below. Use the manufacturer packaging codes from Packaging, or you will get £9999 results <div>
        <textarea>{`sku\tgbTargetMargin\teuTargetMargin	usTargetMargin	rowTargetMargin\tauTargetMargin\tcaTargetMargin\tcostPrice	duty	weight	costPriceCurrency	packaging	largeLetter	currency\tcanadaDutyId
        123123	30	30	30	30	30\t32\t12	0	600	gbp	KE1	FALSE	gbp\t1
        234234	30	45	30	30	30\t32\t10	0	600	gbp	D	FALSE	gbp\t4`}
        
        </textarea></div></div>
        <Form onSubmit={props.onSubmit}>
            <Form.Label>input:</Form.Label>
            <Form.Control as="textarea" placeholder="Download file, update and paste in here" name="input" style={{ height: "30vh" }}></Form.Control>
            <Button type="submit">Submit</Button>
        </Form>
        <div>
            {props.submitted && <textarea style={{ height: "30vh", width: "100%"}} value={
                `sku\tGB Price\tUS Price\tEU Price\tROW Price\tAU Price\tCA Price\tTotal Weight\tProduct Cost\tPackaging Cost\ttGB Shipping Cost\tUS Shipping Cost\tEU Shipping Cost\tROW Shipping Cost\tAU Shipping Cost\tCA Shipping Cost` + 
                Object.values(props.output).map((line) => {
                    return "\n" + [line.sku,
                        line.salePrice.GB.regionalIncVatRounded,
                        line.salePrice.US.regionalIncVatRounded,
                        line.salePrice.EU.regionalIncVatRounded,
                        line.salePrice.ROW.regionalIncVatRounded,
                        line.salePrice.AU.regionalIncVatRounded,
                        line.salePrice.CA.regionalIncVatRounded,
                        line.totalWeight,
                        line.costPriceGbp,
                        line.packagingCost,
                        line.shippingCost.GB,
                        line.shippingCost.US,
                        line.shippingCost.EU,
                        line.shippingCost.ROW,
                        line.shippingCost.AU,
                        line.shippingCost.CA
                        
                    ].join('\t')
                })
            }></textarea>}
        </div>

    </div>
}